<template>
  <div class="fill-value-table" :class="{ 'fill-value-table__disabled': disable }">
    <scrollbar>
      <table>
        <thead>
          <tr>
            <th>{{ headerTitle }}</th>
            <template v-for="(title, index) in headerValues">
              <th :key="`header-title-${index}`">{{ title }}</th>
            </template>
          </tr>
        </thead>
        <tbody>
          <template v-for="(title, titleIndex) in bodyTitles">
            <tr :key="`body-title-${titleIndex}`">
              <td>{{ title }}</td>

              <template v-for="(value, valueIndex) in bodyValues[titleIndex]">
                <td :key="`body-value-${titleIndex}-${valueIndex}`">
                  <imask-input
                    v-model="bodyValues[titleIndex][valueIndex]"
                    type="text"
                    unmask="typed"
                    radix="."
                    :mask="Number"
                    :map-to-radix="[',']"
                    :scale="9"
                    :min="0"
                    :disabled="disable"
                    @complete="onComplete"
                    @focus="onFieldFocus"
                  />
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </table>
    </scrollbar>
  </div>
</template>

<script>
import IMaskComponent from "../common/imask-input";

export default {
  name: "FillValueTable",
  components: {
    "imask-input": IMaskComponent
  },
  props: {
    headerTitle: {
      type: String,
      default: ""
    },
    headerValues: {
      type: Array,
      default: () => []
    },
    bodyTitles: {
      type: Array,
      default: () => []
    },
    bodyValues: {
      type: Array,
      default: () => []
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onComplete() {
      this.$emit("change", this.bodyValues);
    },
    onFieldFocus(event) {
      if (parseInt(event.target.value, 10) === 0) {
        event.target.select();
      }
    }
  }
};
</script>
